import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import App from './App'
import Vue from 'vue'
import './uni.promisify.adaptor'
import store from './store/index.js'
import uView from "uview-ui";
Vue.use(uView);

Vue.config.productionTip = false
App.mpType = 'app'
Vue.prototype.$store = store;

store.dispatch('getHeight') // 获取系统状态栏高度/手机型号

const app = new Vue({
  ...App
})

app.$mount()